


















































































































































































import Vue from 'vue'
import { currency } from '@/helper/constants'
import CheckoutService from '@/services/CheckoutService'
import {
  createCategoryPostTree,
  extractInstructorInfoFromCustomization
} from '@/helper'
import ProductSlider from '../../common/ProductSlider.vue'
import Product from '@/models/Product'
import NovaCategoryPostTree from '../../common/NovaCategoryPostTree.vue'
import UISpinner from '@/components/common/UISpinner.vue'
import { Instructor } from '@/models/ProductCustomization'
import InstructorCard from '@/components/product/InstructorCard.vue'
import { adminMode } from '@/helper/permission.helper'

export default Vue.extend({
  components: {
    ProductSlider,
    NovaCategoryPostTree,
    UISpinner,
    InstructorCard
  },
  props: {
    upsellOffer: {
      type: Object
    },
    offer: {
      type: Object
    },
    products: {
      type: Array
    },
    offerAlreadyPurchased: Boolean,
    disableCheckoutBtn: {
      type: Boolean,
      default: false
    },
    url: String
  },
  async mounted() {
    this.selectedProduct = this.products[0]
    await this.fetchCategories(this.selectedProduct.id)
  },
  metaInfo() {
    const meta = {}
    meta['link'] = [
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css?family=Lato',
        vmid: 'novaUpsellFont'
      }
    ]
    return meta
  },
  data() {
    return {
      currency,
      categoryTree: [],
      selectedProduct: {} as Product,
      loading: false
    }
  },
  computed: {
    instructor(): Instructor {
      if (this.selectedProduct && this.selectedProduct.customizations) {
        return extractInstructorInfoFromCustomization(
          this.selectedProduct.customizations
        )
      }
      return null
    },
    upsellSettings(): object {
      return this.upsellOffer.settings?.upsellSettings
    },
    courseBody(): object {
      return this.upsellSettings?.courseBody
    },
    upsellDetails(): object {
      return this.upsellSettings?.upsellDetails
    },
    upsellProductDesc(): object {
      return this.courseBody?.product || {}
    },
    purchaseBtnContent(): string {
      return this.upsellDetails?.purchaseButton?.content
    },
    purchaseBtnColor(): string {
      return this.upsellDetails?.purchaseButton?.color || '#1a202c'
    },
    backgroundColor(): string {
      return this.upsellDetails?.backgroundColor
    },
    titleAlignment(): string {
      return `text-${this.upsellDetails?.title?.alignment || 'center'}`
    },
    subTitleAlignment(): string {
      return `text-${this.upsellDetails?.subTitle?.alignment || 'center'}`
    },
    selectedProductDesc(): string {
      return (
        (this.upsellProductDesc &&
          this.upsellProductDesc[this.selectedProduct.id]) ||
        this.selectedProduct.description
      )
    },
    courseCurriculumTitle() {
      return this.courseBody?.curriculum?.content || 'Course Curriculum'
    },
    courseDescriptionTitle() {
      return this.courseBody?.descriptionTitle?.content || 'Course Curriculum'
    },
    isAdmin() {
      return adminMode()
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    }
  },
  methods: {
    async fetchCategories(productId: string) {
      try {
        this.loading = true
        const { data: categories } = await CheckoutService.getCategories(
          productId
        )
        this.categoryTree = []
        this.categoryTree = createCategoryPostTree(null, categories)
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async changeSelectedProduct(id) {
      const product = this.products.find(product => product.id === id)
      this.selectedProduct = product
      await this.fetchCategories(this.selectedProduct.id)
    },
    backToLibrary() {
      this.$router.push({
        name: 'library-v2'
      })
    }
  }
})
